import * as React from 'react';
import { useSelector } from 'react-redux';

import { AgentInfoContainer, DeveloperInfoContainer, HomeownerInfoContainer } from './parts';
import { CardSection } from '../../components/CardSection';
import { selectIsAgencyBottomBrandingAvailable, selectIsAgencyBrandingAvailable } from '../../selectors';
import { selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';
import { AuthorPremiumContainer } from '../AuthorPremiumContainer';
import { SubscriptionAuthorBrandContainer } from '../subscriptionBrand';

export const BottomAuthorBlockContainer: React.FC = () => {
  const isAgencyBrandingAvailable = useSelector(selectIsAgencyBrandingAvailable);
  const isAgencyBottomBrandingAvailable = useSelector(selectIsAgencyBottomBrandingAvailable);
  const isNewbuildingPremium = useSelector(selectIsNewbuildingPremiumRate);

  if (isAgencyBrandingAvailable && isAgencyBottomBrandingAvailable) {
    return <SubscriptionAuthorBrandContainer />;
  }

  if (isNewbuildingPremium) {
    return <AuthorPremiumContainer />;
  }

  return (
    <CardSection id="author">
      <HomeownerInfoContainer />
      <AgentInfoContainer />
      <DeveloperInfoContainer />
    </CardSection>
  );
};
